/**
 * Shared rule for every internal order form (technologist form, preorder review popup,
 * "New order" popup): at least a comment OR an attachment is required.
 * Order-level attachments only; position attachments do not count.
 */
export function hasCommentOrAttachment(formData: any): boolean {
    const hasComment = typeof formData?.comment === 'string' && formData.comment.trim().length > 0;
    const hasAttachmentFiles = Array.isArray(formData?.attachments) && formData.attachments.some(Boolean);
    const hasAttachmentRows = (formData?.attachmentRows ?? []).some((row: any) => !!row?.file);

    return hasComment || hasAttachmentFiles || hasAttachmentRows;
}